export const preventBodyScroll = (value) => {
    const body = document.getElementsByTagName('body')[0].classList

    if (value) {
        body.add('prevent-body-scroll')
    } else {
        body.remove('prevent-body-scroll')
    }
}
